import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  fetchCompanyById,
  fetchCompanies,
  updateCompany,
  updateStatusInCompany,
  fetchCompanyByDropDown,
} from "./thunk";

interface CompanyState {
  companyList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCompany: any;
}

const initialState: CompanyState = {
  companyList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCompany: null,
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
       .addCase(fetchCompanyByDropDown.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyByDropDown.fulfilled, (state, action) => {
        state.loading = false;
        state.companyList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchCompanyByDropDown.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch companies";
      })
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.loading = false;
        state.companyList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch companies";
      })
      .addCase(fetchCompanyById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCompanyById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCompany = action.payload;
      })
      .addCase(fetchCompanyById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateCompany.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.companyList = state.companyList.map((company) =>
          company.id === action.payload.id ? action.payload : company
        );
      })
      .addCase(updateCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update company";
      })
      .addCase(updateStatusInCompany.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.companyList = state.companyList.map((company) =>
          company.id === action.payload.id ? action.payload : company
        );
      })
      .addCase(updateStatusInCompany.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update company status";
      });
  },
});

export default companySlice.reducer;
